<script setup lang="ts">
import { ref } from 'vue'

const openAbrLookupModal = ref(false)
const openDNSInfoModal = ref(false)
const openGeneratePasswordModal = ref(false)
</script>

<template>
    <RouterLink
        to="/system/categories"
        class="block py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
    >
        <div class="flex items-center">
            <div class="w-6 ml-1">
                <FontAwesomeIcon :icon="['fal', 'server']" class="size-4!" />
            </div>
            <div class="ml-2 text-xs">System Settings</div>
        </div>
    </RouterLink>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
